import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSearchResultsByType as GetSearchResultsQuery,
    GetSearchResultsByTypeVariables as GetSearchResultsQueryVariables,
    GetSearchResultsByType_search_quickResults as QuickResults,
} from 'nutshell-graphql-types';

import GET_SEARCH_RESULTS_BY_TYPE from '../queries/get-search-results-by-type.graphql';

export const useGetSearchResults = (input: {query: string}) => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
        GET_SEARCH_RESULTS_BY_TYPE,
        {
            variables: {query: input.query},
            fetchPolicy: 'network-only',
        }
    );

    const search = data ? data.search : null;

    const quickResults: QuickResults | null | undefined = search && search.quickResults;

    const recentResults = quickResults && quickResults.recentResultsByType;
    const leadResults = quickResults && quickResults.leadResults;
    const accountResults = quickResults && quickResults.accountResults;
    const contactResults = quickResults && quickResults.contactResults;

    return {
        recentResults: recentResults,
        leadResults: leadResults || [],
        accountResults: accountResults || [],
        contactResults: contactResults || [],
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
